<template>
    <h2>Installiere Schillerando als App</h2>
    <h3>Edge</h3>
    <p>Um Schillerando als App zu nutzen, klicke in der Adresszeile auf die drei Quadrate und das "+".</p>
    <h3>Chrome</h3>
    <p>Um Schillerando als App zu nutzen, klicke in der Adresszeile auf den Bildschirm mit dem nach unten zeigenden Pfeil.</p>
    <h3>Safari</h3>
    <h4>iOS &amp; iPadOS</h4>
    <p>Um Schillerando als App zu nutzen, öffne das "Teilen"-Menü und klicke dort auf "Zum Home-Bildschirm". Abschließend musst du noch einmal oben rechts auf "Hinzufügen" drücken, dann ist Schillerando als App auf deinem Gerät nutzbar.</p>
    <h4>macOS</h4>
    <p>Auf macOS ist es mit Safari leider noch nicht möglich, Schillerando als App zu nutzen.</p>
    <h3>Firefox</h3>
    <p>Firefox unterstützt leider Schillerando als App noch nicht.</p>
  </template>
  
  <script>
  export default {
    name: 'AppView',
  };
  </script>
  
